import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
import { ISearchProtocolsResult, ISearchRequest } from "../shared/interfaces";

const controller = 'Search';

const search = (aooId: number, searchRequest: ISearchRequest, cancelToken?: CancelToken): Promise<ISearchProtocolsResult> => {
    return axiosInstance.post(`${controller}/${aooId}/Search`, searchRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    search,
}